export const EXTERNAL_PRESENTER_INVOICE_FORM_BY_TOKEN = `
  query externalPresenterInvoiceFormByToken($token: String!) {
    externalPresenterInvoiceFormByToken(token: $token) {
      __typename
      ... on ExternalPresenterInvoiceFormData {
        token_status
        presenterName
        presenterFirstname
        presenterLastname
        presenterEmail
        groupName
        meetingDate
        meetingType
        topicName
        chairName
        payAmount
        expensesLimit
        perDiemAvailable
        travelEligibleBase
        programProvinceId
        provinces {
          id
          name
        }
        topicCategories {
          id
          name
        }
        billing_enabled
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const EXTERNAL_PRESENTER_INVOICE_BY_MEETING = `
  query externalPresenterInvoiceByMeeting($meeting_id: Int!, $tenant_id: Int!) {
    externalPresenterInvoiceByMeeting(meeting_id: $meeting_id, tenant_id: $tenant_id) {
      __typename
      ... on ExternalPresenterInvoiceData {
        id
        status
        invoice_amount
        per_diem_amount
        load_date
        presenter_firstname
        presenter_lastname
        presenter_email
        phone
        province_id
        province_name
        topic_category_id
        topic_category_name
        bank
        bank_account_type
        branch_office
        branch_office_number
        account_holder
        cbu
        cuit
        has_invoice_file
        has_expenses_file
        has_receipt_file
        provinces {
          id
          name
        }
        topicCategories {
          id
          name
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const EXTERNAL_PRESENTER_INVOICE_FILE_LINK = `
  query externalPresenterInvoiceFileLink($meeting_id: Int!, $file_type: String!, $tenant_id: Int!) {
    externalPresenterInvoiceFileLink(meeting_id: $meeting_id, file_type: $file_type, tenant_id: $tenant_id) {
      __typename
      ... on StringResult {
        result
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
